import * as React from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import { Translate } from '../../../../../shared/LanguageService';
import * as Features from '../../../../../shared/Features';
import SuccessSnackbar from '../../../../../shared/feedback/SuccessSnackbar';
import FailureSnackbar from '../../../../../shared/feedback/FailureSnackbar';
import { useMarkBookingRequestAsHandledMutation } from '../queries/useMarkBookingRequestAsHandledMutation';

type BookingRequestNoticeProps = {
    orderId: number;
    canBeMarkedAsHandled: boolean;
    user: unknown;
};

function BookingRequestNotice({ orderId, canBeMarkedAsHandled, user }: BookingRequestNoticeProps) {
    const markBookingRequestAsHandled = useMarkBookingRequestAsHandledMutation(orderId);
    const [showFailure, setShowFailure] = React.useState(false);
    const [showSuccess, setShowSuccess] = React.useState(false);

    if (!Features.hasFeature(Features.UpdateOrderState, user)) {
        return null;
    }

    return (
        <>
            {canBeMarkedAsHandled && !markBookingRequestAsHandled.isSuccess && (
                <Alert
                    severity="info"
                    sx={{ mt: 2, alignItems: 'center' }}
                    action={
                        <Button
                            color="inherit"
                            size="small"
                            disabled={markBookingRequestAsHandled.isLoading}
                            onClick={() =>
                                markBookingRequestAsHandled.mutate(undefined, {
                                    onSuccess: () => setShowSuccess(true),
                                    onError: () => setShowFailure(true)
                                })
                            }
                        >
                            {Translate('view-order/basic-order-info/booking-request/mark-as-handled')}
                        </Button>
                    }
                >
                    {Translate('view-order/basic-order-info/booking-request/notice')}
                </Alert>
            )}
            <SuccessSnackbar
                open={showSuccess}
                onClose={() => setShowSuccess(false)}
                text={Translate(
                    'view-order/basic-order-info/booking-request/mark-as-handled/success'
                )}
            />
            <FailureSnackbar
                open={showFailure}
                onClose={() => setShowFailure(false)}
                text={Translate(
                    'view-order/basic-order-info/booking-request/mark-as-handled/failure'
                )}
            />
        </>
    );
}

export default BookingRequestNotice;
